export default __webpack_public_path__ + "static/media/product1.04365345.webp";